'use strict';

(function() {
	angular.module('dat.shared-components.session')
		.directive('datSessionTimeout', datSessionTimeout);

	datSessionTimeout.$inject = ['eventNameService'];

	var eventNameService;

	function datSessionTimeout(_$log_, _eventNameService_) {
		eventNameService = _eventNameService_;

		return {
			scope: {
				showTimeoutUi: '=',
				productName: '@',
				productImageClass: '@',
				forgotUsernameCallback: '&',
				forgotPasswordCallback: '&',
				loginCallbackPromise: '&'
			},
			templateUrl: '/app/shared-components/session/timeout.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {
		activate();

		//////////////////////////////////////////

		function activate() {
			scope.forgotUsername = forgotUsername;
			scope.forgotPassword = forgotPassword;
			scope.login = login;

			scope.$on(eventNameService.sessionLogin.loginSuccessful, onloginSuccessful);
		}

		function forgotUsername() {
			scope.forgotUsernameCallback();
		}

		function forgotPassword() {
			scope.forgotPasswordCallback();
		}

		function login() {
			return scope.loginCallbackPromise();
		}

		function onloginSuccessful() {
			scope.showTimeoutUi.show = false;
		}
	}
})();
